import { render, staticRenderFns } from "./Backer.vue?vue&type=template&id=795c7fad&scoped=true"
import script from "./Backer.vue?vue&type=script&lang=ts"
export * from "./Backer.vue?vue&type=script&lang=ts"
import style0 from "./Backer.vue?vue&type=style&index=0&id=795c7fad&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "795c7fad",
  null
  
)

export default component.exports